module.exports = __webpack_public_path__ + "img/product_item_bg3.e2d72b28.png";